<!-- <div><i class="material-icons icon-btn" style="float: right;" (click)="close()">close</i></div> -->
<iframe width="100%" height="660px" frameborder="0" [src]="link"></iframe>